export const categoryList = [
    {
        value: "mine",
        label: "proposal_list_my",
        clearablevalue: false
    },
    {
        value: "group",
        label: "proposal_list_team",
        clearablevalue: false
    },
    {
        value: "all",
        label: "proposal_list_all_proposals",
        clearablevalue: false
    },
]


// WEBPACK FOOTER //
// ./src/ProposalList/categoryList.js